import {
  GRADING_MODE_LABELS,
  getGradeSelectOptions,
  normalizeGradingMode,
} from "../utils/gradeValues";

export default function GradeFormatFields({
  format,
  value,
  onFormatChange,
  onValueChange,
  className = "ag-input",
  compact = false,
}) {
  const mode = normalizeGradingMode(format);
  const options = getGradeSelectOptions(mode) || [];

  return (
    <div className={compact ? "grade-format-fields grade-format-fields--compact" : "grade-format-fields"}>
      <select
        className={className}
        value={mode}
        onChange={(e) => onFormatChange(e.target.value)}
        title="Typ wpisu"
      >
        {Object.entries(GRADING_MODE_LABELS).map(([key, label]) => (
          <option key={key} value={key}>
            {compact ? label.split(" ")[0] : label}
          </option>
        ))}
      </select>
      {mode === "percent" ? (
        <input
          type="number"
          min="0"
          max="100"
          className={className}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          placeholder="%"
        />
      ) : (
        <select className={className} value={value} onChange={(e) => onValueChange(e.target.value)}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
